import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { ToastrService } from 'ngx-toastr'

@Injectable({
    providedIn: 'root',
})
export class NotificationService {
    constructor(
        private toasterService: ToastrService,
        private router: Router,
    ) {}

    public success(message: string, title?: string, preventDuplcates = false): void {
        this.toasterService.toastrConfig.preventDuplicates = preventDuplcates
        this.toasterService.success(message, title)
    }
    public error(message: string, title?: string, preventDuplcates = false): void {
        this.toasterService.toastrConfig.preventDuplicates = preventDuplcates
        this.toasterService.error(message, title)
    }
    public info(message: string, title?: string, preventDuplcates = false, navTo = ''): void {
        this.toasterService.toastrConfig.preventDuplicates = preventDuplcates
        this.toasterService.info(message, title).onTap.subscribe(() => {
            if (navTo) {
                this.router.navigateByUrl(navTo)
            }
        })
    }
    public warning(message: string, title?: string, preventDuplcates = false): void {
        this.toasterService.toastrConfig.preventDuplicates = preventDuplcates
        this.toasterService.warning(message, title)
    }
}
